// extracted by mini-css-extract-plugin
module.exports = {"BatchPage":"BatchPage_BatchPage__2Kh5r","BatchPage__stepper":"BatchPage_BatchPage__stepper__2fm8K","BatchPage__content":"BatchPage_BatchPage__content__2Qggz"};